__turbopack_context__.v({
  "button": "BackToTop-module-scss-module__1i30DW__button",
  "icon": "BackToTop-module-scss-module__1i30DW__icon",
});
